import {SAVEPARAMS} from "./mutations-type"
export default{
  [SAVEPARAMS](state,form){
    state.form = form
  }
}